import { Alert, Skeleton } from '@mui/material';

import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';

import { useActivityQuery } from 'api/hooks/useActivityLog';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

export const ActivityDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const location = useLocation();

  const { data } = useActivityQuery(parseInt(id || '0'));

  usePageHeading({
    heading: t(translations.pages.activityLog.title()),
    headingProps: {
      back: location.state?.back ?? '/activity-log'
    }
  });

  if (!data) {
    return <Skeleton variant="rounded" height={'80vh'} />;
  }

  if (!data.dataBefore || !data.dataAfter) {
    return <Alert severity="error">{t(translations.pages.activityLog.noDiffData())}</Alert>;
  }

  return (
    <ReactDiffViewer
      compareMethod={DiffMethod.WORDS}
      oldValue={JSON.stringify(JSON.parse(data.dataBefore || '{}'), undefined, 1)}
      newValue={JSON.stringify(JSON.parse(data.dataAfter || '{}'), undefined, 1)}
    />
  );
};
